export const res = {
  privacy: {
    is: 'Persónuvernd',
    en: 'Privacy',
    pl: 'Prywatność',
  },
  privacyLink: {
    is: 'https://www.landsbankinn.is/bankinn/um-bankann/personuvernd',
    en: 'https://www.landsbankinn.is/en/the-bank/about-us/privacy',
    pl: 'https://www.landsbankinn.is/en/the-bank/about-us/privacy',
  },
  legalNotice: {
    is: 'Lagalegur fyrirvari',
    en: 'Legal notice',
    pl: 'Nota prawna',
  },
  legalNoticeLink: {
    is: 'https://www.landsbankinn.is/fyrirvari',
    en: 'https://www.landsbankinn.is/en/disclaimer',
    pl: 'https://www.landsbankinn.is/en/disclaimer',
  },
};
